
import * as yup from 'yup';
import ValidationMessage from '../../constants/Validation/ValidationMessage';
import ValidationMessageAlbanian from '../../constants/Validation/ValidationMessageChange';


const local_language = localStorage.getItem('lang')


const MyProfileDetailValidation = yup.object().shape({
    location: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("vendndodhjen") :ValidationMessage.Field("location")),

    // description: yup.string().required(ValidationMessage.Field("description"))
    //     .min(50, ValidationMessage?.MinLength('description', 50))
    //     .max(300, ValidationMessage?.MaxLength('description', 300)),

    description: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.Field("përshkrim") : ValidationMessage.Field("description"))
        .min(50, local_language == "alb" ? ValidationMessageAlbanian.MinLength('përshkrim', 50) : ValidationMessage.MinLength('description', 50))
        .max(300, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('përshkrim', 300) : ValidationMessage.MaxLength('description', 300)),

    image: yup.array().of(
        yup.object().shape({
            file_path: yup.string().required(local_language == "alb" ? ValidationMessageAlbanian.SelectField('imazh') : ValidationMessage.SelectField("Image")),
            media_id: yup.string().nullable(),
        })
    ).min(5, local_language == "alb" ? ValidationMessageAlbanian.MinLength('imazh', 5) : ValidationMessage.MinField(5, "image")).max(10, local_language == "alb" ? ValidationMessageAlbanian.MaxLength('imazh', 10) : ValidationMessage.MaxField(10, "image")).required(),

   
    phone_number: yup.string()
        .required(local_language == "alb" ? ValidationMessageAlbanian.Field("Numri i telefonit") : ValidationMessage.Field("phone number"))
        .min(7, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER)
        .max(15, local_language == "alb" ? ValidationMessageAlbanian.PHONE_MAX_CHAR : ValidationMessage.PHONE_MAX_CHAR)
        .matches(/^[0-9]*$/, local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE_NUMBER : ValidationMessage.VALID_PHONE_NUMBER) // Allow only digits
        .test('valid-phone', local_language == "alb" ? ValidationMessageAlbanian.VALID_PHONE : ValidationMessage.VALID_PHONE, value => {
            // Ensure phone number is not just repeated '0's
            if (!value) return true; // Return true if value is not provided (handled by required validation)

            if (/^0+$/.test(value)) {
                return false; // Reject if all characters are '0'
            }

            return true;
        }),


});

export default MyProfileDetailValidation;
